<template>
  <div class="info">
    <div class="thanking-out-loud-campaign elevation-0">
      <div class="thanking-out-loud-campaign-copy">
        <h1>
          What is the
          <br />
          <span class="black-text">#thankingoutloud</span>
          <br />campaign?
        </h1>
        <p class="thanking-out-loud-campaign-copy1">
          Doctors, nurses, hospital staff, and other frontline workers around the country are working restlessly and risking their lives to save the rest of us during this COVID19 pandemic. They are the heroes of our generation and nothing we ever say will be enough to thank them for this sacrifice. But we can try:
          Broadcast on Dub your audio messages of gratitude and encouragement and we will compile and share broadly to keep them energized! #thankingoutloud
        </p>
      </div>

      <div class="stores">
        <div>
          <p>
            <strong>See more @thankingoutloud notes and leave yours.</strong>
          </p>
        </div>
        <div class="store-items">
          <a
            href="https://apps.apple.com/us/app/dub-live-commentary/id1476464895?mt=8"
            style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2020-02-12&kind=iossoftware&bubble=ios_apps) no-repeat;width:135px;height:40px;"
          ></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.dubcommentary.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              style="position:relative;height:58px; margin-top: -9px"
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            />
          </a>
        </div>
      </div>
    </div>

    <v-card class="about" color="primary" dark>
      <h2 color="white">About Dub</h2>
      <p
        class="about-copy"
      >Dub is the new app for live audio — think Instagram Live or Twitch, but audio-only (more convenience and flexibility). It lets you easily create and listen to live audio streams using only your phone. Commentary, interviews, and stories about the news, reality shows, politics, sports, and anything else that is happening in the world. It's live audio created by anyone, in any language, and available to everyone.</p>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "info"
};
</script>

<style scoped>
.info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100vh;
}

.thanking-out-loud-campaign {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex-grow: 2;
  padding-left: 60px;
  padding-right: 30px;
}

.store-items {
  display: flex;
  align-items: stretch;
  margin-bottom: 50px;
}

.about {
  padding-top: 80px;
  padding-left: 60px;
  padding-right: 30px;
  border-top-left-radius: 30px !important;
  border-top-right-radius: 30px !important;
  align-self: end;
}

.thanking-out-loud-campaign-copy > h1 {
  color: #6b6a75;
}

.black-text {
  color: black;
}

.thanking-out-loud-campaign-copy1 {
  margin-top: 50px;
}

.about-copy {
  margin-top: 50px;
  margin-bottom: 70px;
  font-size: 1em;
  line-height: 1.41;
}
</style>
